<template>
    <h2 class="mr-snap-title template4">
        <div v-if="isMobileSize" class="mobile">
            <div class="title-container">
                <div class="mg-title" v-html="formatFontSize(title, '--mg-title-size')"></div>
                <div class="time" v-if="time">{{ time }}</div>
            </div>
            <a
                :href="featureAreaMarketRefineLink()"
                v-if="
                    featureAreaMarketRefineLink && featureAreaMarketRefineLink()
                "
                rel="noopener noreferrer"
                class="refine-market"
            ><i class="iconfont icon-community"></i>{{ $t('md-snapshot-search.refineSearch') }}</a>
        </div>
        <div v-else class="pc">
            <div class="title-container">
                <div class="mg-title" v-html="formatFontSize(title, '--mg-title-size')"></div>
                <span class="time" v-if="time">{{ time }}</span>
            </div>
            <a
                :href="featureAreaMarketRefineLink()"
                v-if="
                    featureAreaMarketRefineLink && featureAreaMarketRefineLink()
                "
                rel="noopener noreferrer"
                class="refine-market"
            ><i class="iconfont icon-community"></i>{{ $t('md-snapshot-search.refineSearch') }}</a>
        </div>
    </h2>
</template>

<script>
export default {
    name: 'SnapTitle',
    i18next: {
        ns: 'md-snapshot-search'
    },
    props: {
        title: {
            type: String,
            required: true
        },
        time: String // market snapshot  next time
    },
    computed: {
        isMobileSize() {
            return this.platform.isMobile;
        }
    },
    inject: ['featureAreaMarketRefineLink']
};
</script>

<style lang="scss">
.mr-snap-title.template4 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .refine-market {
        font-size: 14px;
        color: #505050;
        font-family: var(--font-medium);
        line-height: 26px;
        display: flex;
        align-items: center;
        .iconfont.icon-community {
            margin-right: 10px;
            color: #a8a8a8;
        }
    }
    .pc {
        padding: 30px 0 0 0;
        .time {
            font-size: 16px;
        }
    }
    .mobile {
        padding: 20px;
        .time {
            font-size: 14px;
        }
    }
    .pc .mg-title,
    .mobile .mg-title {
        display: block;
        white-space: pre-wrap;
    }
    .desc {
        margin-right: 10px;
    }
    .time {
        font-family: var(--font-normal);
        color: var(--color-disable);
    }
    .pc, .mobile {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        .mg-title{
            width: auto;
        }
    }
}
</style>
